export default {
    heading: {
        label: 'Schedule name',
        placeholder: 'Enter the schedule name.. You can use the name of the person responsible for it.',
        tool_tip_message: 'Enter the schedule name.. You can use the name of the person responsible for it.',
    },
    from_date: {
        label: 'Start date',
        placeholder: 'Select date',
        tool_tip_message: 'Start date of the schedule',
    },
    to_date: {
        label: 'End date',
        placeholder: 'Select date',
        tool_tip_message: 'End date of the schedule',
    },
    max_days: {
        label: 'Allow max days in advance',
        placeholder: 'Enter number',
        tool_tip_message: 'Maximum number of days that users could book the slots in advance.',
    },
}
